import { create } from "zustand";

export interface CommonState {
  activeTab: string;
  setActiveTab: (activeTab: string) => void;
  displayInbox: boolean;
  setDisplayInbox: (displayInbox: boolean) => void;
  displayNotifications: boolean;
  setDisplayNotifications: (displayNotifications: boolean) => void;
  closeBrowser: boolean;
  setCloseBrowser: (closeBrowser: boolean) => void;
}

export const useCommonStore = create<CommonState>((set) => ({
  activeTab: "home",
  setActiveTab: (activeTab) => set({ activeTab }),
  displayInbox: false,
  setDisplayInbox: (displayInbox) => set({ displayInbox }),
  displayNotifications: false,
  setDisplayNotifications: (displayNotifications) =>
    set({ displayNotifications }),
  closeBrowser: false,
  setCloseBrowser: (closeBrowser) => set({ closeBrowser }),
}));
